module.exports = __webpack_public_path__ + "img/colombia.864484ab.png";